
class Route {
    path: string;
    title: string;
    description: string;

    constructor(path: string, title: string, description: string) {
        this.path = path;
        this.title = title;
        this.description = description
    }
}

class AppRoutes {
    AUTH = new Route('/auth', 'Auth', 'Unauthenticated shell.')
    LOGIN = new Route('/auth/login', 'Login', 'Email and password sign in.')
    ENABLE_2FA = new Route('/auth/enable-2fa', 'Enable 2FA', 'Legacy setup link, redirects authenticated admins to Profile.')
    FORGOT_PASSWORD = new Route('/auth/forgot-password', 'Forgot Password', 'Request a password reset link.')
    RESET_PASSWORD = new Route('/auth/reset-password', 'Reset Password', 'Set a new password from a reset link.')

    MAIN = new Route('/main', 'Main', 'Authenticated dashboard shell.')
    DASHBOARD = new Route('/main/dashboard', 'Dashboard', 'Landing page, open to every authenticated admin.')
    USERS = new Route('/main/users', 'Users', 'Customer accounts, KYC and account requests.')
    TRANSACTIONS = new Route('/main/transactions', 'Transactions', 'All transactions across types.')
    DEPOSITS = new Route('/main/deposits', 'Deposits', 'Deposit transactions.')
    TRANSFERS = new Route('/main/transfers', 'Transfers', 'Transfer transactions.')
    BAMBOO_TRANSFERS = new Route('/main/bamboo-transfers', 'Bamboo Transfers', 'Pending Bamboo transfers. Super admin only.')
    CHARITY = new Route('/main/charity', 'Charity', 'Charities and their campaigns.')
    VIEW_DONORS = new Route('/main/charity/view-donors/:id', 'View Donors', 'Donors for a single charity.')
    PROFILE = new Route('/main/profile', 'Profile', 'Your own admin account.')
    ADMIN_USERS = new Route('/main/admin-users', 'Admin Users', 'Admin accounts, invites and access areas. Super admin only.')
    FEATURE_FLAGS = new Route('/main/feature-flags', 'Feature Flags', 'Feature availability. Super admin only.')
    AUDIT_TRAIL = new Route('/main/audit-trail', 'Audit Trail', 'Log of admin actions.')
    FLAGGED_USERS = new Route('/main/flagged-users', 'Flagged Users', 'Sanctions screening hits awaiting review.')
    EXCHANGE_RATES = new Route('/main/exchange-rates', 'Exchange Rates', 'Currency pairs, fees and payout types.')
    BENEFICIARIES = new Route('/main/beneficiaries', 'Beneficiaries', 'Beneficiary accounts and screening status.')
    CURRENCIES = new Route('/main/currencies', 'Currencies', 'Supported currencies and their limits.')
    MARKETING = new Route('/main/marketing', 'Marketing', 'Voucher marketing area, redirects to the overview.')
    MARKETING_OVERVIEW = new Route('/main/marketing/overview', 'Marketing Overview', 'Matching books, onboarding pipeline and what needs attention.')
    PARTNERS = new Route('/main/marketing/partners', 'Partners', 'Voucher partners across onboarding and live.')
    ONBOARD_PARTNER = new Route('/main/marketing/partners/onboard', 'Onboard Partner', 'Business details, branches and sign-in, then review and create.')
    PARTNER_DETAILS = new Route('/main/marketing/partners/:partnerId', 'Partner Details', 'A single partner with branches, payments, devices and activity.')
    VOUCHERS = new Route('/main/marketing/vouchers', 'Vouchers', 'Voucher batches, vouchers and email delivery.')
    ISSUE_VOUCHERS = new Route('/main/marketing/vouchers/issue', 'Issue Vouchers', 'Partner and amount, recipients, then review against the prepaid balance.')
    VOUCHER_BATCH_DETAILS = new Route('/main/marketing/vouchers/batches/:batchId', 'Batch Details', 'A single voucher batch and its vouchers.')
    REDEMPTIONS = new Route('/main/marketing/redemptions', 'Redemptions', 'Completed voucher redemptions across partners.')

    CATCH_ALL = new Route('*', 'Not Found', 'Anything unmatched, redirected to login.')
}

export const ROUTES = new AppRoutes()
